import script from "./TableSelectionActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableSelectionActions.vue?vue&type=script&setup=true&lang=ts"

import "./TableSelectionActions.vue?vue&type=style&index=0&id=74128d66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74128d66"]])

export default __exports__